import type { ChatRoomCreateRequestRoomInfoType } from './chatRoomCreateRequestRoomInfoType';

/**
 * 채팅방 정보
 */
export type ChatRoomCreateRequestRoomInfo = {
  name?: string;
  type?: ChatRoomCreateRequestRoomInfoType;
};
